class DynamicYields {
	constructor() {
		this.dySyncCart(); // Sync cart on each page refresh
	}

	/**
	 *	The user has added a product to the cart. 
	 */
	dyAddtoCart() {
		(async () => {
			this.getCart().then((cart) => {
				const dyCart = [];
				if (cart.item_count > 0) {
					cart.items.forEach(item => {
						if (item.line_price > 0) {
							dyCart.push({
								productId: item.sku,
								quantity: item.quantity,
								itemPrice: parseFloat(item.line_price / 100),
							});
						}
					});
				}

				if (dyCart.length > 0) {
					DY.API('event', {
						name: 'Add to Cart',
						properties: {
							dyType: 'add-to-cart-v1',
							value: dyCart[0].itemPrice,
							currency: currencyCode,
							productId: dyCart[0].productId,
							quantity: 1,
							cart: dyCart
						}
					});
					// this.dySyncCart();
				}
			});
		})();
	} // dyAddtoCart

	/**
	 * This event updates the current cart state.
	 */
	dySyncCart() {
		(async () => {
			this.getCart().then((cart) => {
				const dyCart = [];
				if (cart.item_count > 0) {
					cart?.items?.forEach(item => {
						if (item.line_price > 0) {
							dyCart.push({
								productId: item.sku,
								quantity: item.quantity,
								itemPrice: parseFloat(item.line_price / 100),
							})
						}
					})

					DY.API('event', {
						name: 'Sync cart',
						properties: {
							dyType: 'sync-cart-v1',
							currency: currencyCode,
							cart: dyCart
						}
					});
				}

			});
		})();

	} // dySyncCart


	/**
	 * The user has removed a product from the cart.
	 */
	dyRemoveFromCart(dyItemRemovedIndex) {

		(async () => {
			this.getCart().then((cart) => {
				const dyCart = [];
				const removeItem = [];
				if (cart.item_count > 0) {
					let count = 1
					cart?.items?.forEach(item => {
						if (item.line_price > 0) {
							if (count === parseInt(dyItemRemovedIndex)) {
								removeItem.push({
									productId: item.sku,
									quantity: item.quantity,
									itemPrice: parseFloat(item.line_price / 100),
								});
							} else {
								dyCart.push({
									productId: item.sku,
									quantity: item.quantity,
									itemPrice: parseFloat(item.line_price / 100),
								})
							}
						}
						count = count + 1;
					})

				}

				DY.API('event', {
					name: 'Remove from Cart',
					properties: {
						dyType: 'remove-from-cart-v1',
						value: removeItem[0].itemPrice,
						currency: currencyCode,
						productId: removeItem[0].productId,
						quantity: removeItem[0].quantity,
						cart: dyCart
					}
				});
			});
		})();

	} // dyRemoveCart

	/**
	 * Retrieve a JSON respresentation of the users cart
	 *
	 * @return {Promise} - JSON cart
	*/
	async getCart() {
		try {
			const response = await fetch('/cart.js');
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const cart = await response.json();
			return cart;
		} catch (error) {
			console.error('There has been a problem with your fetch operation:', error);
		}
	}

}

// Instantiate the class and assign it to a global variable
window.dynamicYields = new DynamicYields();
